const CookiePolicy = () => (
  <div className="container Padding-Top">
    <h1>Cookie Policy</h1>
    <p>
      This Cookie Policy explains how we use cookies and similar technologies on our wholesale website 
      for sarees, lehengas, readymade garments, and gowns. By continuing to browse or use our services, 
      you agree to the use of cookies as described here.
    </p>

    <h3>What Are Cookies?</h3>
    <p>
      Cookies are small text files placed on your device when you visit our website. 
      They help us remember your preferences, understand how you interact with our site, 
      and improve your browsing and ordering experience.
    </p>

    <h3>Why We Use Cookies</h3>
    <ul>
      <li><strong>Essential Cookies</strong> – Required for our site to function, including secure login, 
          cart management, and checkout for wholesale orders.</li>
      <li><strong>Performance & Analytics Cookies</strong> – Help us understand website traffic, 
          product demand trends (e.g., most-viewed sarees or lehengas), and improve site navigation.</li>
      <li><strong>Functionality Cookies</strong> – Remember your preferences such as language, currency, 
          and recently viewed products.</li>
      <li><strong>Marketing Cookies</strong> – Used to show relevant offers, discounts, and new arrivals 
          tailored to your interests.</li>
    </ul>

    <h3>Third-Party Cookies</h3>
    <p>
      We may use trusted third-party services like Google Analytics, Meta Pixel, or advertising partners 
      to help us better understand buyer behavior and run targeted wholesale promotions.
    </p>

    <h3>Managing Cookies</h3>
    <p>
      You can control and/or delete cookies through your browser settings. 
      Most browsers allow you to refuse cookies or alert you when cookies are being sent. 
      However, blocking certain cookies may impact your ability to place wholesale orders 
      or use some features of our website.
    </p>

    <h3>Updates to This Policy</h3>
    <p>
      We may update this Cookie Policy from time to time to reflect changes in our business practices 
      or legal requirements. Please revisit this page periodically to stay informed.
    </p>

    <p>
      If you have any questions about our Cookie Policy, please contact us at&nbsp;
      <a href="mailto:info@hs-india.com">info@hs-india.com</a>.
    </p>
  </div>
);

export default CookiePolicy;